<template>
  <p class='description' v-if="getProductDetail.product" v-html="getProductDetail.product.description"></p>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'ProductDescription',
  computed: {
    ...mapGetters([
      'getProductDetail'
    ])
  }
}
</script>

<style type='text/css' lang='scss' scoped>
  .description {
    color: #000000;
    font-size: 16px;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productDetail/productDescription.vue